import React from "react";
import '../sass/index.scss';
import { DarkModeToggle } from "./DarkModeToggle";

const HeaderFooter = ({ children }) => {
    return(
        <div id="wrap">
            <div id="header-container">
                <div className="content-left">
                    <h1>
                        394 IT
                    </h1>
                </div>
                <div className="content-right">
                    <DarkModeToggle />
                </div>
            </div>
            <div id="main">
                <div style={{maxWidth:"886px",margin:"auto"}}>
                    { children }
                </div>
            </div>
            <div id="footer-container">
                <p className="dark-text">Site design / logo © 2023 394it <br /> user contributions licensed under The MIT License</p>
            </div>
        </div>
    );
};

export default HeaderFooter;